import React from 'react';

const AccountSectionLayout = ({
  children,
  classes,
  style
}: {
  children: React.ReactNode;
  classes?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <div className={`${classes}`} style={style}>
      {children}
    </div>
  );
};

export default AccountSectionLayout;
